export default "__VITE_ASSET__PoU9aCY5__"